module.exports = __webpack_public_path__ + "static/media/Aerotech.81fb7326.png";